import React, { Dispatch, createContext, useContext, useEffect, useReducer } from 'react';
import { formatISO } from "date-fns"


export interface Multistep_campaign_data {
    data: Record<string, any>;
    in_wizard_mode?: boolean;
}

const CampaignCreationReducer = (state: Multistep_campaign_data, action: { type: string , payload ?: any }) => {
    switch (action.type) {
      case 'SET_STATE': {
        return action.payload;
      }
      case 'SET_STEP1_DATA': {
        let step1 = state.data.step1;
        step1 = {
            ...step1,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step1
            }
        }
      }
      case 'SET_STEP2_DATA': {
        let step2 = state.data.step2;
        step2 = {
            ...step2,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step2
            }
        }
      }
      case 'SET_START_END_DATE': {
        let step1 = state.data.step1;
        step1 = {
            ...step1,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step1
            }
        }
      }
      case 'SET_TARGET_NETWORKS': {
        let step1 = state.data.step1;
        step1 = {
            ...step1,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step1
            }
        }
      }
      case 'SET_FILE_ID': {
        let step2 = state.data.step2;
        step2 = {
            ...step2,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step2
            }
        }
      }
      case 'SET_VIDEO_ID': {
        let step2 = state.data.step2;
        step2 = {
            ...step2,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step2
            }
        }
      }
      case 'SET_TASK_ID': {
        let step2 = state.data.step2;
        step2 = {
            ...step2,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step2
            }
        }
      }
      case 'SET_FACEBOOK_IMAGE_HASH': {
        let step2 = state.data.step2;
        step2 = {
            ...step2,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step2
            }
        }
      }
      case 'SET_TIKTOK_IMAGE_HASH': {
        let step2 = state.data.step2;
        step2 = {
            ...step2,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step2
            }
        }
      }
      case 'SET_TIKTOK_VIDEO_ID': {
        let step2 = state.data.step2;
        step2 = {
            ...step2,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step2
            }
        }
      }
      case 'SET_CONVERSION_STATUS': {
        let step2 = state.data.step2;
        step2 = {
            ...step2,
            ...action.payload
        }
        return {
            ...state,
            data: {
                ...state.data,
                step2
            }
        }
      }
      case 'SET_AVAILABLE_CTAS': {
        let step1 = state.data.step1;
        step1 = {
            ...step1,
            available_ctas: action.payload.available_ctas
        }
        return {
            ...state,
            data: {
                ...state.data,
                step1
            }
        }
      }
      default: {
        throw new Error(`Unhandled action type: ${action.type}`)
      }
}}

const MultistepCreateCampaignContext = createContext<[Multistep_campaign_data | undefined, Dispatch<any>] |undefined>([undefined, () => {}]);


const initial_state : Multistep_campaign_data = {
    "data": {
        "step1": {
            "name": "",
            "objective": "LINK_CLICKS",
            "budget_mode": "DAILY",
            "start_time": formatISO(new Date(), { representation: 'complete' }),
            "end_time": null,
            "networks": {
                "meta": false,
                "linkedin": false,
                "tiktok": false
            },
            "brand_id": undefined,
            "audience_id": undefined,
            "meta_budget": 100,
            "meta_bid_amount": 1.8,
            "meta_placements": ["facebook_positions__feed", "instagram_positions__explore", "instagram_positions__explore_home", "instagram_positions__stream"],
            "linkedin_placements": ["FEED"],
            "linkedin_budget": 100,
            "linkedin_bid_amount": 1.8,
            "tiktok_budget": 100,
            "tiktok_bid_amount": 1.8,
            "tiktok_placements": ["TIKTOK_IN_FEED"],
            "meta_cta": undefined,
            // meta options that used to be fixed in code: the pixel came only
            // from the brand, the budget was always on the ad set, and
            // advantage+ audience was hardcoded off
            "meta_pixel_id": undefined,
            "meta_budget_level": "ADSET",
            "meta_bid_strategy": undefined,
            "meta_advantage_audience": false,
            "meta_leadgen_form_id": undefined,
            "linkedin_cta": undefined,
            "tiktok_cta": undefined,
            "available_ctas": {
                "facebook": [],
                "linkedin": [],
                "tiktok": []
            }
        },
        "step2": {
            "headline": "",
            "message": "",
            "link": "",
        }
    },
    "in_wizard_mode": false
}

export const MultistepCreateCampaignProvider = ({ children, in_wizard_mode = false }: { children: React.ReactNode, in_wizard_mode?: boolean }) => {
    const [state, dispatch] = useReducer(CampaignCreationReducer, {...initial_state, in_wizard_mode});

    return (
        <MultistepCreateCampaignContext.Provider value={[state, dispatch]}>
            {children}
        </MultistepCreateCampaignContext.Provider>
    );
}


export const useMultistepCreateCampaignContext = () => {
    const context = useContext(MultistepCreateCampaignContext);
    if (!context) {
        throw new Error("useMultistepCreateCampaignContext must be used within a MultistepCreateCampaignProvider");
    }
    return context;
}
